type Location = {
  lat: number;
  lng: number;
}

// lifted src/app/helpers/location.helper.ts
// Made it a little easier to use with typed arguments

const getDistanceBetween = ({ origin, destination }: { origin: Location, destination: Location }): number => {
  const EARTH_RADIUS = 6378137; // in meters
  const getRadian = (angle: number) => angle * (Math.PI / 180);

  const dLat = getRadian(origin.lat - destination.lat);
  const dLong = getRadian(origin.lng - destination.lng);

  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(getRadian(origin.lat)) * Math.cos(getRadian(destination.lat)) *
    Math.sin(dLong / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distanceMeters = EARTH_RADIUS * c;

  return Math.round(distanceMeters / 1609.344); // ✅ convert to miles
};


export { Location, getDistanceBetween };
